<template>
   <div class='history-bill-list'>
      <div v-if="showbillList" class="bill-list">
         <!-- 历史账单 -->
         <h2 class="history-bill">{{$t('bstext.bs13')}}</h2>
         <div class="history-bill-content" v-for="item in billList" :key="item.year">
            <!-- 年 -->
            <h3 class="history-bill-year">{{item.year}}{{$t('bstext.bs16')}}</h3>
            <div class="history-bill-block">
               <p class="history-bill-cell" v-for="item1 in item.month" :key="item1.month" @click="billDetail(item1)">
                  <!-- 月账单 -->
                  <span>{{$t('bstext.bs17',{msg:item1.month})}}</span>
                  <!-- 待支付 -->
                  <i class="arrow" v-if="item1.status==payStatus.nonPaid||item1.status==payStatus.overdue">{{$t('bstext.bs14')}}</i>
                  <i class="arrow" v-else>{{item1.currencySymbol}}{{item1.amount | formatPrice}}</i>
               </p>
            </div>
         </div>
      </div>
      <div v-else class="no-bill-list">
         <span class="bs-icon-no-bill"></span>
         <!--  您当前暂无账单信息 -->
         <p>{{$t('bstext.bs15')}}</p>
      </div>
   </div>
</template>

<script>
export default {
   data () {
      return {
         showbillList:false,
         billList:[], 
         lang:localStorage.getItem('lang')        
      }
   },
   computed:{
      payStatus(){
         return this.$store.state.payStatus
      },
      month(){
         return this.$store.state.month
      }
   },
   mounted() {
      // 历史账单
      document.title = this.$t('bstext.bs13')
      this.getBillList()
   },
   methods: {
      getBillList(){
         this.$appApi.nativeLoading(true,'',0)
         let req ={}
         this.$server.getBillList(req).then(res=>{
            let list =res.data
            if(list){
               list.forEach(item => {
                  item.month.forEach(item2=>{
                  item2.month=this.lang=='en'?this.month[item2.month]:item2.month
                  })
               });
               this.billList=list
               this.showbillList=true
            }else{
               this.showbillList=false
            }
         }).finally(()=>{
            this.$appApi.nativeLoading(false,'',0)
         })
      },
      billDetail(item){
         this.$router.push(`/bs/battswap/billdetail/${item.ono}`)
      }
   }
}
</script>

<style lang='less' scoped>
.history-bill-list{
   box-sizing: border-box;
   min-height: 100vh;
   padding: 16px 12px;
   background: #F7F8FA;
   .bill-list{    
     .history-bill{
         margin-top: 8px;
         font-size: 18px;
         font-weight: 500;
         color: #21242C;
         line-height: 25px;
     }
      .history-bill-content{
         // padding-bottom: 4px;
         .history-bill-year{
            margin: 20px 0 12px;
            font-size: 16px;
            font-weight: 500;
            color: #21242C;
            line-height: 22px;
         }
         .history-bill-block{
            background: #FFFFFF;
            border-radius: 2px;
            .history-bill-cell{
               display: flex;
               justify-content: space-between;
               align-items: center;
               padding: 12px;
               border-bottom: 1px solid rgba(33, 36, 44, .1);
               font-size: 14px;
               color: #21242C;
               line-height: 20px;
               &:last-child{
                  border-bottom: none;
               }
               span{
               }
               .arrow::after {
                  // right: 0;
                  content: "";
                  width: 8px;
                  height: 8px;
                  display: inline-block;
                  border-top: 2px solid #8C92A0;
                  border-right: 2px solid #8C92A0;
                  transform: rotate(45deg);
                  margin-left: 5px;
               }
            }
         }
      }
   }
   .no-bill-list{
      margin-top: 51.2vw;
      text-align: center;
      p{
         font-size: 14px;
         color: #8C92A0;
         line-height: 14px;
         margin-top: 16px;
      }
   }
}
</style>


// WEBPACK FOOTER //
// src/components/blueshark/battswap/mybill/historybill.vue